import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="prvc-container">
      <h1 className="prvc-title">Privacy Policy</h1>

      <section className="prvc-section">
        <h2 className="prvc-subtitle">Who Are We?</h2>
        <p className="prvc-text">
          Our website address is:{" "}
          <a href="https://sundori.latechnologies.net" className="prvc-link">
            https://sundori.latechnologies.net
          </a>
        </p>
      </section>

      <section className="prvc-section">
        <h2 className="prvc-subtitle">Use of Personal Data Collected</h2>
        <h3 className="prvc-subsubtitle">Content Booked From Other Sites</h3>
        <p className="prvc-text">
          Articles on this site may include embedded content (e.g., videos,
          images, articles). Content embedded from other sites behaves in the
          same way as if the visitor were to visit the other site. These
          websites may collect data about you, use cookies, embed third-party
          tracking tools, and track your interactions with embedded content if
          you have a connected account on their website.
        </p>
      </section>

      <section className="prvc-section">
        <h2 className="prvc-subtitle">Statistics and Hearing Measures</h2>
        <p className="prvc-text">
          This site uses Google Analytics, a web analytics service provided by
          Google Inc. (“Google”). Google Analytics uses cookies, which are text
          files placed on your computer, to help the website analyze the use of
          the site by its users. The data generated by the cookies concerning
          your use of the site (your IP address is not communicated) will be
          transmitted and stored by Google on servers located in the United
          States.
        </p>
        <p className="prvc-text">
          Google will use this information for the purpose of evaluating your
          use of the site, compiling reports on website activity, and providing
          other services relating to website activity and use of the Internet.
          Google may disclose such data to third parties in the event of a legal
          obligation or where such third parties process such data on Google’s
          behalf.
        </p>
        <p className="prvc-text">
          We do not send your IP address to Google, so it will not be
          cross-referenced with other data held by Google. You can disable the
          use of cookies by selecting the appropriate settings on your browser.
          However, this may prevent the use of certain features on this site. By
          using this website, you expressly consent to the processing of your
          personal data by Google under these conditions and for the purposes
          described above.
        </p>
      </section>

      <section className="prvc-section">
        <h2 className="prvc-subtitle">Contact Information</h2>
        <p className="prvc-text">
          Email:{" "}
          <a href="mailto:contact@latechnologies.net" className="prvc-link">
            contact@latechnologies.net
          </a>
        </p>
        <p className="prvc-text">
          The information completed in the contact form is not stored. It is
          sent directly by email to our community manager.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
